import { Select } from '@consta/uikit/Select'
import { Text } from '@consta/uikit/Text'
import type { MovingAverageParams } from '@core/core/types'
import { SingleInput } from '@library/model'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import { weightCoefficients } from '../constants'
import css from '../MapBuildingRightMenu.css'
import type { MovingAverageAlgorithmMenuProps, WeightCoefficientItemsType } from '../types'

export const MovingAverageAlgorithmMenu: FC<MovingAverageAlgorithmMenuProps> = ({
  formData,
  updateMovingAverageData,
}) => {
  const onWeightCoefficientChange = (value: Nullable<WeightCoefficientItemsType>) => {
    if (value) {
      updateMovingAverageData(prev => {
        if (prev) {
          return { ...prev, weightCoefficient: value.key }
        }
      })
    }
  }

  const onParamChange = (key: keyof MovingAverageParams) => (value: Nullable<string>) => {
    updateMovingAverageData(prev => {
      if (prev) {
        return { ...prev, [key]: value ? Number(value) : value }
      }
    })
  }

  return (
    <>
      <Select
        label="Способ задания весовых коэффициентов"
        size="xs"
        items={weightCoefficients}
        value={
          formData.movingAverage?.weightCoefficient === 'Equals' ? weightCoefficients[0] : null
        }
        getItemKey={item => item.key}
        getItemLabel={item => item.label}
        onChange={onWeightCoefficientChange}
      />
      <Text className={css.textAfterSpace} size="xs" view="secondary">
        Параметры поискового эллипса:
      </Text>
      <div className={css.rowMenuFields}>
        <div className={css.columnMenuFields}>
          <Text size="xs" view="secondary">
            Большая полуось, м
          </Text>
          <SingleInput
            value={formData.movingAverage?.ellipseBigRadius}
            mode="integer"
            min={1}
            max={30000}
            withClearButton={true}
            className={css.validatedTextFields}
            onChange={onParamChange('ellipseBigRadius')}
          />
        </div>
        <div className={css.columnMenuFields}>
          <Text size="xs" view="secondary">
            Малая полуось, м
          </Text>
          <SingleInput
            value={formData.movingAverage?.ellipseSmallRadius}
            mode="integer"
            min={1}
            max={30000}
            withClearButton={true}
            className={css.validatedTextFields}
            onChange={onParamChange('ellipseSmallRadius')}
          />
        </div>
      </div>
      <div className={css.rowMenuFields}>
        <div className={css.columnMenuFields}>
          <Text size="xs" view="secondary">
            Азимут анизотропии
          </Text>
          <SingleInput
            value={formData.movingAverage?.anisotropyAngle}
            mode="integer"
            min={-90}
            max={90}
            withClearButton={true}
            className={css.validatedTextFields}
            onChange={onParamChange('anisotropyAngle')}
          />
        </div>
        <div className={css.columnMenuFields}>
          <Text size="xs" view="secondary">
            Мин. кол-во точек
          </Text>
          <SingleInput
            value={formData.movingAverage?.neighborsCount}
            mode="integer"
            min={1}
            withClearButton={true}
            className={css.validatedTextFields}
            onChange={onParamChange('neighborsCount')}
          />
        </div>
      </div>
    </>
  )
}
